import { Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";

function SearchFanTableHeaders(props: any) {

  return (
    <>
    <div>
      <InputLabel
        id={"select-standard-".concat(props.label)}
        style={{ fontSize: "large", fontWeight:'700' }}
      >
        {props.label}
      </InputLabel>
    </div>
    <FormControl
      variant="standard"
      style={{ margin: 1, minWidth: props.minSize }}
    >
      <select
        name={props.name}
        id={"id-select-standard-".concat(props.label)}
        onChange={props.handleChange}
        value={props.values}
        style={{backgroundColor:'#e3eae7',border:"none",outline:"none",borderRadius:"10px",marginTop:"10px",fontSize:"20px",height:'30px',paddingLeft:'15%', }}
      >
        <option value="" style={{outline:"none"}}>
          SELECT
        </option>
        { props.options && 
          props.options.map((element:any) => {
            debugger;
            return (
              <option value={element}>{element}</option>
            )
          })
        }
      </select>
    </FormControl>
    </>
  );
}


{/* <Autocomplete
style={{ margin: 1, minWidth: props.minSize }}
value={props.values}
onInputChange={props.handleChange}
options={props.options}
freeSolo
renderInput={(params: any) => (
  <TextField
    {...params}
    label={props.label}
    variant="outlined"
  />
)}

// onBlur={handleAddNewItem}
// onKeyDown={(event: any) => {
//   if (event.key === 'Enter') {
//     handleAddNewItem();
//   }
// }} */}
export default SearchFanTableHeaders;
